__turbopack_context__.v({
  "loader": "loader-module__8f7vZW__loader",
  "loading": "loader-module__8f7vZW__loading",
  "wrapper": "loader-module__8f7vZW__wrapper",
});
